import { render, staticRenderFns } from "./ChatMediaUploader.vue?vue&type=template&id=723c3098"
import script from "./ChatMediaUploader.vue?vue&type=script&lang=js"
export * from "./ChatMediaUploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports